<template>
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-text class="text-center">
          <v-row align="center" justify="center">
            <v-col cols="12" class="headline">
              {{$t('new_application_header')}}
            </v-col>
            <v-col cols="12" >
              {{$t('new_applications_body')}}
            </v-col>
            <v-col cols="12">
              <v-btn color="primary" to="/panel/my_applications" @click="openMyApplications()">{{$t('go_to')}}</v-btn>
            </v-col>
          </v-row>          
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'newApplicationModal',
  data() {
    return {
    };
  },
  computed: {
    isOpen() {
      return this.$store.getters.IS_NEW_APPLICATION_MODAL_OPENED;
    }
  },
  methods: {
    openMyApplications() {
      this.$store.dispatch('OPEN_NEW_APPLICATION_MODAL', false);
    },
  },
};
</script>
